var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-height app-absolute-layout",class:[{ scrollable: _vm.scrollable, withGrid: _vm.withGrid }, _vm.styleClass]},[_c('div',{staticStyle:{"overflow-x":"scroll"},attrs:{"id":"Layout"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }